import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NewsletterData } from '@fcp/lib-ui';
import { NewsletterContainerService } from './newsletter-container.service';

@Component({
  selector: 'fcp-newsletter-container',
  template: `<fcp-newsletter [newsletter]="data | async"></fcp-newsletter>`
})

export class NewsletterContainerComponent implements OnInit {
  @Input() private id: string;
  public data: Observable<NewsletterData>
  constructor(private newsletterContainerService: NewsletterContainerService) { }

  ngOnInit() {
    this.data = this.newsletterContainerService.getFormulario(this.id);
   }
}
